var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      ["AccountGroupsRetrieve", "AccountMembersRetrieve"].includes(
        _vm.$route.name
      )
        ? [
            _c(
              "div",
              { staticClass: "d-flex mb-5" },
              [
                _c("v-spacer"),
                _c("v-skeleton-loader", {
                  attrs: { transition: "fade-transition", type: "button" },
                }),
                _c("v-skeleton-loader", {
                  staticClass: "ml-2",
                  attrs: { transition: "fade-transition", type: "button" },
                }),
              ],
              1
            ),
            _c(
              "v-card",
              { staticClass: "bgPanel pt-6 rounded", attrs: { flat: "" } },
              [
                _c(
                  "v-col",
                  { staticClass: "px-5", attrs: { cols: "2" } },
                  [
                    _c("v-skeleton-loader", {
                      staticClass: "skeleton-group",
                      attrs: { transition: "fade-transition", type: "text" },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    class: [
                      "d-flex mt-2 px-5",
                      { "pb-3": _vm.$route.name === "AccountMembersRetrieve" },
                    ],
                  },
                  [
                    _c(
                      "v-row",
                      { staticClass: "mb-1" },
                      [
                        _c(
                          "v-col",
                          { staticClass: "px-0 pl-3", attrs: { cols: "3" } },
                          [
                            _c("v-skeleton-loader", {
                              staticClass: "skeleton-group",
                              attrs: {
                                transition: "fade-transition",
                                type: "text",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          {
                            class: `ml-12 pl-10, ${
                              _vm.$route.name !== "AccountMembersRetrieve"
                                ? "mt-n5"
                                : ""
                            }`,
                            attrs: {
                              cols:
                                _vm.$route.name === "AccountMembersRetrieve"
                                  ? 5
                                  : 6,
                            },
                          },
                          [
                            _c("v-skeleton-loader", {
                              staticClass: "skeleton-group",
                              attrs: {
                                transition: "fade-transition",
                                type:
                                  _vm.$route.name !== "AccountMembersRetrieve"
                                    ? "list-item-two-line"
                                    : "text",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("v-divider"),
                _c(
                  "div",
                  { staticClass: "d-flex px-5" },
                  [
                    _c(
                      "v-row",
                      { staticClass: "ma-0", attrs: { "no-gutters": "" } },
                      [
                        _c(
                          "v-col",
                          {
                            staticClass: "pb-4 pt-6",
                            attrs: {
                              cols: "7",
                              order:
                                _vm.$route.name === "AccountMembersRetrieve"
                                  ? 2
                                  : 1,
                            },
                          },
                          [
                            _c(
                              "v-col",
                              { staticClass: "px-0", attrs: { cols: "5" } },
                              [
                                _c("v-skeleton-loader", {
                                  staticClass: "skeleton-group",
                                  attrs: {
                                    transition: "fade-transition",
                                    type: "text",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "v-row",
                              {},
                              [
                                _c(
                                  "v-col",
                                  { staticClass: "pl-0 pr-10" },
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "pb-0 pt-2",
                                        attrs: { cols: "8" },
                                      },
                                      [
                                        _c("v-skeleton-loader", {
                                          staticClass: "skeleton-group",
                                          attrs: {
                                            transition: "fade-transition",
                                            type: "text",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c("v-skeleton-loader", {
                                      staticClass: "skeleton-group",
                                      attrs: {
                                        transition: "fade-transition",
                                        type: "list-item-three-line",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  { staticClass: "px-0" },
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "pb-0 pt-2",
                                        attrs: { cols: "8" },
                                      },
                                      [
                                        _c("v-skeleton-loader", {
                                          staticClass: "skeleton-group",
                                          attrs: {
                                            transition: "fade-transition",
                                            type: "text",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c("v-skeleton-loader", {
                                      staticClass: "skeleton-group",
                                      attrs: {
                                        transition: "fade-transition",
                                        type: "list-item-three-line",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          {
                            class: [
                              "pb-4 pt-6",
                              _vm.$route.name === "AccountMembersRetrieve"
                                ? "pr-10 mr-10"
                                : "pl-10 ml-10",
                            ],
                            style: `border-${
                              _vm.$route.name !== "AccountMembersRetrieve"
                                ? "left"
                                : "right"
                            }: 1px solid var(--light-grey-50) !important`,
                            attrs: {
                              order:
                                _vm.$route.name === "AccountMembersRetrieve"
                                  ? 1
                                  : 2,
                            },
                          },
                          [
                            _c(
                              "v-col",
                              { staticClass: "px-0", attrs: { cols: "8" } },
                              [
                                _c("v-skeleton-loader", {
                                  staticClass: "skeleton-group",
                                  attrs: {
                                    transition: "fade-transition",
                                    type: "text",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "v-row",
                              {},
                              [
                                _c(
                                  "v-col",
                                  { staticClass: "px-0" },
                                  [
                                    _c("v-skeleton-loader", {
                                      staticClass: "skeleton-group",
                                      attrs: {
                                        transition: "fade-transition",
                                        type: "list-item-three-line",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        : _vm._e(),
      _vm.type === "inf"
        ? [
            _c(
              "v-col",
              [
                _c("v-skeleton-loader", {
                  attrs: {
                    transition: "fade-transition",
                    type: "text",
                    width: "160",
                  },
                }),
              ],
              1
            ),
            _c(
              "v-col",
              [
                _c("v-skeleton-loader", {
                  attrs: {
                    transition: "fade-transition",
                    type: "text",
                    width: "160",
                  },
                }),
              ],
              1
            ),
          ]
        : _vm._e(),
      _vm.type === "permissions"
        ? [
            _c(
              "v-col",
              { staticClass: "pa-0" },
              [
                _c("v-skeleton-loader", {
                  staticClass: "skeleton-group",
                  attrs: {
                    tile: "",
                    transition: "fade-transition",
                    type: "image",
                    height: 60,
                  },
                }),
                _c("v-divider"),
                _c("v-skeleton-loader", {
                  staticClass: "skeleton-group",
                  attrs: {
                    tile: "",
                    transition: "fade-transition",
                    type: "image",
                    height: 60,
                  },
                }),
                _c("v-divider"),
                _c("v-skeleton-loader", {
                  staticClass: "skeleton-group",
                  attrs: {
                    tile: "",
                    transition: "fade-transition",
                    type: "image",
                    height: 60,
                  },
                }),
              ],
              1
            ),
          ]
        : _vm._e(),
      _vm.type === "members"
        ? _vm._l(4, function (elm) {
            return _c(
              "v-row",
              { key: elm },
              _vm._l(2, function (item) {
                return _c(
                  "v-col",
                  { key: item },
                  [
                    _c(
                      "v-row",
                      { attrs: { aling: "center" } },
                      [
                        _c(
                          "v-col",
                          { attrs: { cols: "7" } },
                          [
                            _c("v-skeleton-loader", {
                              attrs: {
                                transition: "fade-transition",
                                type: "text",
                              },
                            }),
                          ],
                          1
                        ),
                        _c("v-spacer"),
                        _c(
                          "v-col",
                          { staticClass: "pl-16 mt-n1" },
                          [
                            _c("v-skeleton-loader", {
                              attrs: {
                                transition: "fade-transition",
                                type: "image",
                                width: 50,
                                height: 25,
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              }),
              1
            )
          })
        : _vm._e(),
      _vm.type === "panel"
        ? _c(
            "div",
            { staticClass: "px-1" },
            [
              _c(
                "v-col",
                { staticClass: "pl-3 pb-0", attrs: { cols: "7" } },
                [
                  _c("v-skeleton-loader", {
                    staticClass: "skeleton-group",
                    attrs: { transition: "fade-transition", type: "text" },
                  }),
                ],
                1
              ),
              _c(
                "v-row",
                { staticClass: "mb-1", attrs: { "no-gutters": "" } },
                _vm._l(2, function (item) {
                  return _c(
                    "v-col",
                    { key: item, attrs: { cols: "6" } },
                    [
                      _c("v-skeleton-loader", {
                        staticClass: "skeleton-group",
                        attrs: {
                          transition: "fade-transition",
                          type: "list-item-two-line",
                        },
                      }),
                    ],
                    1
                  )
                }),
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }